var _defs, _rect, _rect2, _text, _text2, _text3, _text4, _text5, _rect3, _text6, _text7, _rect4, _text8, _text9, _line, _text0, _rect5, _text1, _text10, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLookMenuMaya({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 260",
    width: 620,
    height: 260,
    role: "img",
    "aria-label": "Maya menu bar with the Squarebit Eye menu open, showing Set Up Eye on Selection, Create Demo Eye, and under a Look divider, Export Look and Import Look.",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .panel { fill: #11151c; }\n      .bar   { fill: #1b212b; }\n      .menu  { fill: #232b37; }\n      .hl    { fill: #22d3ee; fill-opacity: 0.14; }\n      .txt   { font-family: ui-sans-serif, system-ui, \"Segoe UI\", sans-serif; font-size: 13px; fill: #cbd5e1; }\n      .dim   { fill: #64748b; }\n      .accent{ fill: #22d3ee; }\n      .label { font-family: ui-sans-serif, system-ui, \"Segoe UI\", sans-serif; font-size: 11px; fill: #64748b; letter-spacing: .04em; }\n      .div   { stroke: #334155; stroke-width: 1; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 620,
    height: 260,
    rx: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "bar",
    x: 12,
    y: 12,
    width: 596,
    height: 30,
    rx: 6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 28,
    y: 32
  }, "File")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 66,
    y: 32
  }, "Edit")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 108,
    y: 32
  }, "Create")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 164,
    y: 32
  }, "Select")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 216,
    y: 32
  }, "Modify")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "hl",
    x: 266,
    y: 16,
    width: 104,
    height: 22,
    rx: 4
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 276,
    y: 32
  }, "Squarebit Eye")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 384,
    y: 32
  }, "Windows")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "menu",
    x: 266,
    y: 48,
    width: 268,
    height: 150,
    rx: 8
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "txt",
    x: 284,
    y: 74
  }, "Set Up Eye on Selection\u2026")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "txt",
    x: 284,
    y: 100
  }, "Create Demo Eye")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "div",
    x1: 278,
    y1: 116,
    x2: 522,
    y2: 116
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 284,
    y: 133
  }, "LOOK")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "hl",
    x: 274,
    y: 140,
    width: 252,
    height: 24,
    rx: 4
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 284,
    y: 157
  }, "Export Look\u2026")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "txt",
    x: 284,
    y: 185
  }, "Import Look\u2026")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 284,
    y: 222
  }, ".json or .usda \u2014 chosen in the file dialog")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLookMenuMaya);
export default __webpack_public_path__ + "static/media/eye-look-menu-maya.f2a335810349829bf5eabc99598521d1.svg";
export { ForwardRef as ReactComponent };